import qs from "query-string"

import { commonApiAuthRequest as _commonApiAuthRequest } from "src/engine/modules/authRequest"

const RUNTIME_ENV = (window && window.APP_RUNTIME_ENV_VARIABLES) || {}

const env = {
  ...process.env,
  ...RUNTIME_ENV,
}

const { REACT_APP_API_ORIGIN } = env

const commonApiAuthRequest = ({ url, params, method = `get`, data }) => {
  const urlWithQuery = qs.stringifyUrl({ url, query: params })

  return _commonApiAuthRequest({
    url: `${REACT_APP_API_ORIGIN}${urlWithQuery}`,
    method,
    data,
  })
}

export default commonApiAuthRequest
